var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import useInnerWidth from 'syf-js-utilities/hooks/useInnerWidth';
import { Table, TableCell, TableHeader, TableHeaderRow, TableRow, TableRowIcon } from './subcomponents';
import { TBody } from './subcomponents/Table';
const DataTable = (_a) => {
    var { className, tableData, isCardTable, breakpoint = 0, onRowClick = null, rowClickIcon = null } = _a, props = __rest(_a, ["className", "tableData", "isCardTable", "breakpoint", "onRowClick", "rowClickIcon"]);
    const currentWidth = useInnerWidth();
    return (React.createElement(Table, Object.assign({ className: className, isCardTable: isCardTable, breakpoint: breakpoint }, props),
        (!breakpoint || currentWidth > breakpoint) && (React.createElement("thead", null,
            React.createElement(TableHeaderRow, { breakpoint: breakpoint },
                tableData[0].map((cell, cellIndex) => (React.createElement(TableHeader, { isCardTable: isCardTable, cellData: cell, key: `${cellIndex + 1}` }))),
                onRowClick ? (React.createElement(TableHeader, { isCardTable: isCardTable, cellData: { value: '' } })) : null))),
        React.createElement(TBody, { as: breakpoint && currentWidth < breakpoint ? 'div' : '' }, tableData.map((row, rowIndex) => {
            if (rowIndex > 0) {
                return (React.createElement(TableRow, { key: `${rowIndex + 1}`, breakpoint: breakpoint, onClick: onRowClick ? () => onRowClick(row, rowIndex) : null },
                    row.map((cell, cellIndex) => (React.createElement(TableCell, { breakpoint: breakpoint, isCardTable: isCardTable, cellData: cell, label: tableData[0][cellIndex], key: `${cellIndex + 1}` }))),
                    onRowClick ? (React.createElement(TableRowIcon, { className: "tablerow-icon", "aria-label": "tablerow-icon", hasRowClickIcon: !!rowClickIcon, isCardTable: isCardTable, breakpoint: breakpoint, cellData: { value: rowClickIcon || '>' } })) : null));
            }
            return null;
        }))));
};
export default DataTable;
